import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Pager, Well } from 'react-bootstrap';
import ResultsPaginator from '../../components/advancedSearch/results/ResultsPaginator';

const LOCAL_STORAGE_ITEMSPERPAGE_KEY = 'PagedItems.itemsPerPage';

export default function PagedItems({ records, after: AfterComponent, component: Component }) {
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(localStorage.getItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY) || 50);
  const topOfPage = useRef(null);
  const totalPages = Math.ceil(records.length / itemsPerPage);

  function gotoPage(page) {
    setPage(page);
    if (topOfPage.current) topOfPage.current.scrollIntoView({ behavior: 'smooth' });
  }

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY, itemsPerPage);
  }, [itemsPerPage]);

  useEffect(() => {
    setPage(1);
  }, [records]);

  function Pager() {
    if (totalPages === 0 || totalPages === 1) return null;
    return (
      <div>
        <Well>
          <div style={{ float: 'left' }}>
            <strong>
              Records {(page - 1) * itemsPerPage + 1} - {Math.min(page * itemsPerPage, records.length)} of{' '}
              {records.length}
            </strong>
          </div>
          <div style={{ float: 'left', marginLeft: 24 }}>
            Show{' '}
            <select
              onChange={(e) => {
                setItemsPerPage(e.target.value);
                gotoPage(1);
              }}
              value={itemsPerPage}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={50}>100</option>
              <option value={50}>200</option>
            </select>{' '}
            per page
          </div>
          <div style={{ float: 'right', marginTop: -9 }}>
            <ResultsPaginator totalPages={totalPages} selectedPage={page} onChangePage={(page) => gotoPage(page + 1)} />
          </div>
        </Well>
      </div>
    );
  }

  const recordsToDraw = records.filter(
    (_item, index) => page * itemsPerPage > index && index >= (page - 1) * itemsPerPage
  );

  return (
    <React.Fragment>
      <div ref={topOfPage} />
      <Pager />
      <Component visibleRecords={recordsToDraw} />
      {(page === totalPages || totalPages === 0) && AfterComponent && <AfterComponent />}
      <Pager />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/common/PagedItems.jsx